import React from 'react'
import { Center } from '@retailer-platform/shared-components'
import { Alert } from '@retailer-platform/shared-components/src/tds'
import { type ApolloError } from '@apollo/client'
import { ErrorPage } from '@retailer-platform/dashboard/gin-and-tonic'
import { useDomainMessages } from '../../utils/domain/intl'
import { useDomainApolloErrorMessage } from '../../utils/domain/apollo'

export interface Props {
  error: ApolloError
  refetch: () => void
}

export function ErrorPageAlert(props: Props) {
  return (
    <Center fillParent>
      <ErrorPage action={props.refetch}>
        <ErrorAlert {...props} />
      </ErrorPage>
    </Center>
  )
}

export const ErrorAlert = (props: Omit<Props, 'refetch'>) => {
  const i18n = useDomainMessages({
    error: 'approvalManagementLibrary.general.unexpectedFetchError',
  })

  const errorMessage = useDomainApolloErrorMessage(props.error, {
    default: 'approvalManagementLibrary.general.retryOrContactSupport',
  })

  return (
    <Alert variant="error">
      <p>
        {i18n.error}
        <br />
        {errorMessage}
      </p>
    </Alert>
  )
}
